import Vue from 'vue';
import VeeValidate from 'vee-validate';
import veevalidateConfig from './config/veevalidate.config';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import first from 'lodash/first';
import tippy from 'vue-tippy';
import store from './store';
import {mapMutations, mapGetters, mapActions} from 'vuex';
import Notification from './utils/notification';
import VS2 from 'vue-script2';
import Vue2Filters from 'vue2-filters';
import * as VueGoogleMaps from 'vue2-google-maps';
import {ValidationProvider} from 'vee-validate';
import Common from './mixins/common';
import ElDialog from './components/Dialog.vue';
import VueScrollTo from 'vue-scrollto';

// Vue Nav Components
import NavApp from '@/navigation/NavApp';
import NavLargeContainer from '@/navigation/containers/NavLargeContainer';
import NavCategoriesLayout from '@/navigation/layouts/NavCategoriesLayout';
import NavCategoriesLink from '@/navigation/components/NavCategoriesLink';
import NavCompactContainer from '@/navigation/containers/NavCompactContainer';
import NavOverlayCompactLayout from '@/navigation/layouts/NavOverlayCompactLayout';
import NavUtilityBarB2cContainer from '@/navigation/containers/NavUtilityBarB2cContainer';

// Directives
import DebugHighlight from '@/directives/debug-highlight.directive';

// Set dynamic path for webpack chunks.
if (!window.webpackHotUpdate) {
  const cdnDynamicFilesRoot = window.ACC.config.cdnDynamicFilesRoot;
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = `${cdnDynamicFilesRoot}${!cdnDynamicFilesRoot.endsWith('/') ? '/' : ''}`;
}

const vueConfig = function(container = '#page') {
  window.VeeValidate = VeeValidate;

  // Directives
  Vue.directive('debug-highlight', DebugHighlight);

  // Enable dev tools
  Vue.config.devtools = !window.ACC.config.isProduction;

  //Enable Vue error and warning on dev and test Environment
  Vue.config.silent = window.ACC.config.isProduction;

  // Load axios configuration and interceptors
  require('./utils/axios/index');

  Vue.use(VS2);
  Vue.use(Vue2Filters);
  Vue.use(VeeValidate, veevalidateConfig);
  Vue.use(VueScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'ease',
    offset: -300,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
  });

  veevalidateConfig.addValidators();

  Vue.use(tippy, {
    animateFill: false,
    arrow: true,
    theme: 'light',
    flipDuration: 0,
    flip: true,
    flipBehavior: ['top', 'right', 'bottom'],
    popperOptions: {
      modifiers: {
        preventOverflow: {
          enabled: true,
        },
      },
    },
  });

  // We aren't loading the map api script here. Instead it is placed onto the page in storeFinderSearchPage.jsp
  Vue.use(VueGoogleMaps);

  Vue.mixin(Common);

  Vue.prototype.$notify = Notification;

  const requireComponent = require.context('./components', true, /[A-Z]\w+\.(vue|js)$/);

  requireComponent.keys().forEach((fileName) => {
    const component = requireComponent(fileName);
    const name = upperFirst(
      camelCase(
        first(
          fileName
            .replace(/^\.\/(.*)\.\w+$/, '$1')
            .split('/')
            .reverse()
        )
      )
    );

    Vue.component(name, component.default || component);
  });

  Vue.component('ValidationProvider', ValidationProvider);
  Vue.component('ElDialog', ElDialog);

  // Navigation
  Vue.component('NavApp', NavApp);
  Vue.component('NavLargeContainer', NavLargeContainer);
  Vue.component('NavCategoriesLayout', NavCategoriesLayout);
  Vue.component('NavCategoriesLink', NavCategoriesLink);
  Vue.component('NavCompactContainer', NavCompactContainer);
  Vue.component('NavOverlayCompactLayout', NavOverlayCompactLayout);
  Vue.component('NavUtilityBarB2cContainer', NavUtilityBarB2cContainer);

  const vm = new Vue({
    store,

    el: container,

    computed: {
      ...mapGetters('backend', ['consumerFriendlyMode', 'advancedOrderingMode']),

      user() {
        return this.$store.state.user;
      },
    },

    created() {},

    mounted() {
      this.$validator.localize(this.$store.state.vvLocale);
    },

    methods: {
      ...mapActions('backend', ['toggleConsumerFriendlyMode', 'toggleAdvancedOrderingMode']),
      ...mapMutations('backend', ['setConsumerFriendlyMode', 'setAdvancedOrderingMode']),

      toast(options) {
        this.$notify(options);
      },

      checkForm(id) {
        const formData = new FormData(document.forms[id]);
        console.table([...formData]);
      },
    },
  });

  window.store = store;
  window.vm = vm;

  window.toast = window.ACC.isB2Bsite && vm.toast ? vm.toast : console.log;
  store.commit('backend/setB2b', window.ACC.isB2Bsite);
};

export default vueConfig;
